(function () {
	const multicolumnSlider = () => {
		const multicolumnSliders = document.querySelectorAll(".featured-products.swiper");

		if(document.querySelectorAll(".featured-products:not(.swiper)").length > 0) {
			document.querySelectorAll(".featured-products:not(.swiper)").forEach(item => {
				if(item.querySelectorAll(".observe-me").length > 0) {
					function createObserver() {
						function handleIntersect(entries, observer) {
							entries.forEach(entry => {
								if (entry.isIntersecting) {
									entry.target.classList.add("is-inview");
									observer.unobserve(entry.target); // Unobserve the element after the first intersection
								}
							});
						}
					
						let options = {
							root: null,
							rootMargin: "0px",
							threshold: 0.1
						};
					
						let observer = new IntersectionObserver(handleIntersect, options);
						
						let targets = item.querySelectorAll(".observe-me");
					
						targets.forEach((target, index) => {
							observer.observe(target);
							target.style.setProperty('--delay', `${index / 4}s`);
						});
					}
					
					createObserver();	
				}	
			})
		}

		if (multicolumnSliders.length === 0) return;

		multicolumnSliders.forEach((slider) => {
			let slides_count = slider.dataset.slidesCount;
			const sectionId = slider.dataset.id;
			const perRow = slider.dataset.perRow;
			const speed = slider.dataset.speed * 1000;
			const autoplay = toBoolean(slider.dataset.autoplay);
			const stopAutoplaySlider = toBoolean(slider.dataset.stopAutoplay);
			let autoplayParm = {};

			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
				};
			}

			if(slides_count > 3) {
				if(slider.querySelectorAll(".featured-products__image-wrapper").length > 0) {
					slider.querySelectorAll(".featured-products__image-wrapper").forEach(item => item.classList.remove("observe-me"));
				}				

				let multiple = slides_count > 3;

				const productsSlider = new Swiper(`#${sectionId} .swiper`, {
					loop: true,
					longSwipesRatio: 0.1,
					allowTouchMove: true,
					speed: speed,
					...autoplayParm,
					breakpoints: {
						0: {
							slidesPerView: 1,
							autoplay: false,
							slidesPerGroup: 1
						},
						576: {
							slidesPerView: +perRow - multiple ? 2 : perRow > 2 ? 1 : 0 + 0.2
						},
						990: {
							slidesPerView: +perRow - (multiple ? 1 : 0) + 0.2
						}
					}
				});
				if (autoplay && stopAutoplaySlider) {
					let duration;
					let distanceRatio;
					let startTimer;
					const swiperWrapperEl = document.querySelector(
						`#${sectionId} .swiper-wrapper`
					);

					const stopAutoplay = () => {
						if (startTimer) clearTimeout(startTimer);

						productsSlider.setTranslate(productsSlider.getTranslate());

						const currentSlideWidth =
							productsSlider.slides[productsSlider.activeIndex].offsetWidth;
						distanceRatio = Math.abs(
							(currentSlideWidth * productsSlider.activeIndex +
								productsSlider.getTranslate()) /
								currentSlideWidth
						);

						duration = productsSlider.params.speed * distanceRatio;
						productsSlider.autoplay.stop();
					};

					const startAutoplay = (delay = duration) => {
						startTimer = setTimeout(() => {
							productsSlider.autoplay.start();
						}, delay);
					};

					swiperWrapperEl.addEventListener("mouseenter", function () {
						stopAutoplay();
					});

					swiperWrapperEl.addEventListener("mouseleave", function () {
						const distance =
							productsSlider.width * productsSlider.activeIndex +
							productsSlider.getTranslate();

						duration = distance !== 0 ? duration : 0;
						productsSlider.slideTo(productsSlider.activeIndex, duration);
						startAutoplay();
					});
				}
			} 
			//else {
			//	function createObserver() {
			//		function handleIntersect(entries, observer) {
			//			entries.forEach(entry => {
			//				if (entry.isIntersecting) {
			//					entry.target.classList.add("is-inview");
			//					observer.unobserve(entry.target); // Unobserve the element after the first intersection
			//				}
			//			});
			//		}
				
			//		let options = {
			//			root: null,
			//			rootMargin: "0px",
			//			threshold: 0.1
			//		};
				
			//		let observer = new IntersectionObserver(handleIntersect, options);
					
			//		let targets = document.querySelectorAll(".observe-me");
				
			//		targets.forEach((target, index) => {
			//			observer.observe(target);
			//			target.style.setProperty('--delay', `${index / 4}s`);
			//		});
			//	}
				
			//	createObserver();				
			//}
		});
	};
	function toBoolean(string) {
		return string === "true" ? true : false;
	}
	document.addEventListener("DOMContentLoaded", function () {
		multicolumnSlider();
		document.addEventListener("shopify:section:load", function () {
			multicolumnSlider();
		});
	});
})();
